<template>
  <div class="pa-page">

    <!-- Hero -->
    <div class="pa-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-school-outline</v-icon>
        </v-avatar>
        <div>
          <div class="pa-hero__title">Editar Datos de {{ menu_name }}</div>
          <div class="pa-hero__sub">Los registros son visibles para todas las sedes a nivel nacional</div>
        </div>
      </div>
      <v-btn small dark text @click="$router.back()">
        <v-icon left small>mdi-arrow-left</v-icon> Volver
      </v-btn>
    </div>

    <form @submit.prevent="validarCampos" novalidate>
      <div class="pa-body">

        <!-- Nota aprobado -->
        <v-alert type="warning" dense outlined class="mb-4" style="font-size:0.82rem;">
          <strong>NOTA:</strong> Cuando el {{ menu_name }} pasa a la fase de aprobado ya no se puede realizar cambios.
        </v-alert>

        <v-row dense>

          <!-- Columna izquierda -->
          <v-col cols="12" md="6">
            <v-card outlined class="pa-section-card mb-4">
              <v-card-title class="pa-section-title py-2 px-4">
                <v-icon small color="indigo darken-2" class="mr-1">mdi-tag-outline</v-icon>
                Clasificación
              </v-card-title>
              <v-card-text class="pt-4 pb-2 px-4">

                <div class="pa-field-label mb-1">Categoría *</div>
                <Categorias :model="postgrado" :default="postgrado.idcategoria" />
                <div class="pa-field-error mb-3" v-if="validation.firstError('postgrado.idcategoria')">
                  {{ validation.firstError('postgrado.idcategoria') }}
                </div>

                <div class="pa-field-label mb-1">
                  Clase NetSuite <span v-show="clasesnet.length" class="red--text">*</span>
                </div>
                <multiselect
                  v-model="postgrado.clase_netsuite_id"
                  :options="clasesnet"
                  track-by="id"
                  label="nombre"
                  :disabled="clasesnet.length == 0"
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"
                  :loading="loading_clasesnet"
                  :placeholder="clasesnet.length ? 'Seleccione...' : 'No hay clases.'"
                  class="pa-multiselect mb-1"
                />
                <div class="pa-field-error mb-3" v-if="validation.firstError('postgrado.clase_netsuite_id')">
                  {{ validation.firstError('postgrado.clase_netsuite_id') }}
                </div>

                <div class="d-flex align-center justify-space-between mb-1">
                  <span class="pa-field-label">Área *</span>
                  <v-btn x-small text color="indigo darken-1"
                    @click="window.$('#modal-narea').modal('show')">
                    <v-icon left x-small>mdi-plus</v-icon> Nueva área
                  </v-btn>
                </div>
                <Areas :model="postgrado" :default="postgrado.idarea" />
                <div class="pa-field-error mb-3" v-if="validation.firstError('postgrado.idarea')">
                  {{ validation.firstError('postgrado.idarea') }}
                </div>

                <v-text-field
                  v-model.trim="postgrado.nombre"
                  label="Nombre *"
                  outlined dense
                  prepend-inner-icon="mdi-format-title"
                  :error-messages="validation.firstError('postgrado.nombre')"
                  class="mt-2"
                />
                <div class="purple--text text--darken-1 mb-3" style="font-size:0.78rem;">
                  <v-icon x-small color="purple darken-1">mdi-information-outline</v-icon>
                  No escriba el nombre de la categoría, el sistema lo agrega automáticamente.
                </div>

              </v-card-text>
            </v-card>

            <v-card outlined class="pa-section-card">
              <v-card-title class="pa-section-title py-2 px-4">
                <v-icon small color="indigo darken-2" class="mr-1">mdi-clock-outline</v-icon>
                Carga académica
              </v-card-title>
              <v-card-text class="pt-4 pb-2 px-4">
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model.trim="postgrado.creditaje"
                      label="Creditaje *"
                      outlined dense
                      prepend-inner-icon="mdi-counter"
                      suffix="Créditos"
                      :error-messages="validation.firstError('postgrado.creditaje')"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model.trim="postgrado.carga_horaria"
                      label="Carga horaria *"
                      outlined dense
                      prepend-inner-icon="mdi-timer-outline"
                      suffix="Horas"
                      :error-messages="validation.firstError('postgrado.carga_horaria')"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model.trim="postgrado.duracion"
                      label="Duración *"
                      outlined dense
                      prepend-inner-icon="mdi-calendar-range-outline"
                      :suffix="uni_dur || ''"
                      :error-messages="validation.firstError('postgrado.duracion')"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="postgrado.unidad_duracion"
                      label="Unidad de duración *"
                      :items="[{v:'0',t:'Meses'},{v:'1',t:'Semanas'},{v:'2',t:'Días'},{v:'3',t:'Horas'}]"
                      item-value="v" item-text="t"
                      outlined dense
                      prepend-inner-icon="mdi-calendar-clock"
                      :error-messages="validation.firstError('postgrado.unidad_duracion')"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Columna derecha -->
          <v-col cols="12" md="6">
            <v-card outlined class="pa-section-card">
              <v-card-title class="pa-section-title py-2 px-4">
                <v-icon small color="indigo darken-2" class="mr-1">mdi-text-box-outline</v-icon>
                Descripción
              </v-card-title>
              <v-card-text class="pt-4 pb-2 px-4">
                <v-textarea
                  v-model.trim="postgrado.dirigido"
                  label="Dirigido a"
                  outlined dense rows="4"
                  prepend-inner-icon="mdi-account-group-outline"
                  placeholder="A quién va dirigido este postgrado..."
                  :error-messages="validation.firstError('postgrado.dirigido')"
                  class="mb-2"
                />
                <v-textarea
                  v-model.trim="postgrado.objetivo"
                  label="Objetivo"
                  outlined dense rows="4"
                  prepend-inner-icon="mdi-bullseye-arrow"
                  placeholder="Objetivo del postgrado..."
                  :error-messages="validation.firstError('postgrado.objetivo')"
                />
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>

        <!-- Submit -->
        <v-card outlined class="pa-section-card mt-4" v-if="$store.state.CARGO.id!=8">
          <v-card-text class="px-4 py-3">
            <Alertas ref="alertar" />
            <p v-if="msg" class="text-center mt-2 grey--text">{{ msg }}</p>
            <div class="d-flex justify-center mt-3">
              <v-btn color="indigo darken-1" dark depressed :disabled="!activo" type="submit" large>
                <v-icon left>mdi-content-save-outline</v-icon> Guardar cambios
              </v-btn>
            </div>
          </v-card-text>
        </v-card>

      </div>
    </form>

    <NuevaArea />
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import gql from 'graphql-tag';
import Areas from '@/components/Areas.vue';
import Categorias from '@/components/ACategorias.vue';
import Alertas from '@/components/AAlertas.vue';
import NuevaArea from '@/components/ANewArea.vue';
import { mapState } from 'vuex';
import xaxios from '@/xaxios';

export default {
  components: { Areas, Categorias, Alertas, NuevaArea },
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      activo: true,
      msg: '',
      uni_dur: '',
      loading_clasesnet: false,
      postgrado: {
        idarea: null,
        idcategoria: null,
        clase_netsuite_id: null,
        nombre: null,
        fase: 0,
        portada: 'portadita',
        creditaje: null,
        duracion: null,
        dirigido: null,
        objetivo: null,
        carga_horaria: null,
        unidad_duracion: null,
        clasenetsuite: null,
      },
      clasesnet: [],
    };
  },
  computed: {
    ...mapState({
      postgrado_value: (state) => state.postgrado.value,
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
  },
  validators: {
    'postgrado.idarea'(value) { return Validator.value(value).required(); },
    'postgrado.idcategoria'(value) { return Validator.value(value).required(); },
    'postgrado.clase_netsuite_id'(value) {
      if (this.clasesnet.length > 0) return Validator.value(value).required();
      return Validator.value(value);
    },
    'postgrado.nombre'(value) { return Validator.value(value).required().minLength(5); },
    'postgrado.portada'(value) { return Validator.value(value).required().minLength(5); },
    'postgrado.fase'(value) { return Validator.value(value).digit().required().maxLength(1).lessThan(3); },
    'postgrado.creditaje'(value) { return Validator.value(value).integer().minLength(0).required().maxLength(4).greaterThan(-1); },
    'postgrado.duracion'(value) { return Validator.value(value).integer().minLength(1).required().maxLength(3).greaterThan(0); },
    'postgrado.carga_horaria'(value) { return Validator.value(value).integer().minLength(1).required().maxLength(5).greaterThan(0); },
    'postgrado.unidad_duracion'(value) { return Validator.value(value).integer().minLength(1).maxLength(5).greaterThan(-1); },
    'postgrado.dirigido'(value) { return Validator.value(value).minLength(5).maxLength(499); },
    'postgrado.objetivo'(value) { return Validator.value(value).minLength(5).maxLength(499); },
  },
  watch: {
    postgrado: {
      deep: true,
      handler() {
        window.sessionStorage.setItem('xpostgrado', JSON.stringify(this.postgrado));
        if (this.postgrado.unidad_duracion != null) {
          const u = this.postgrado.unidad_duracion;
          if (u == '0') this.uni_dur = 'Meses';
          else if (u == '1') this.uni_dur = 'Semanas';
          else if (u == '2') this.uni_dur = 'Días';
          else if (u == '3') this.uni_dur = 'Horas';
          else this.uni_dur = '?';
        }
      },
    },
    'postgrado.idcategoria': function() {
      if (!this.postgrado.idcategoria) return;
      this.getNetSuiteClase();
    },
  },
  methods: {
    validarCampos() {
      this.$validate().then((success) => {
        var obj = window.Object.assign({}, this.postgrado);
        if (obj.duracion != null)        obj.duracion        = window.parseInt(obj.duracion);
        if (obj.unidad_duracion != null) obj.unidad_duracion = window.parseInt(obj.unidad_duracion);
        if (obj.creditaje != null)       obj.creditaje       = window.parseFloat(obj.creditaje);
        if (obj.carga_horaria != null)   obj.carga_horaria   = window.parseFloat(obj.carga_horaria);
        if (obj.clase_netsuite_id)       obj.clase_netsuite_id = obj.clase_netsuite_id.id;
        if (success) {
          obj.idarea = obj.idarea.id;
          obj.idcategoria = obj.idcategoria.id;
          this.$store.state.obj = obj;
          this.$store.dispatch('quitarNulos');
          delete obj.fase;
          this.activo = false;
          this.$refs.alertar.cargando();
          this.enviarDatos(obj);
        } else {
          this.$refs.alertar.invalido();
        }
      });
    },
    async enviarDatos(obj) {
      var vue = this;
      obj.unidad_negocio_id = this.UNIDAD_NEGOCIO_ID;
      delete obj.clasenetsuite;
      var sql = gql`mutation{ updatePostgrado(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      vue.msg = '';
      this.$apollo.mutate({ mutation: sql }).then(({ data }) => {
        if (data.updatePostgrado.ok) {
          vue.$refs.alertar.success();
          window.sessionStorage.setItem('xpostgrado', null);
        } else {
          var ob = JSON.parse(JSON.stringify(data.updatePostgrado.errors));
          var vals = '';
          ob.forEach(function(k) { vals += Object.values(k) + '-\n\t'; });
          vue.activo = true;
          vue.$refs.alertar.invalido(vals);
        }
      }).catch((error) => {
        vue.$refs.alertar.invalido();
        this.activo = true;
        window.console.error(error);
        vue.msg = error;
      });
    },
    async getNetSuiteClase() {
      this.postgrado.clase_netsuite_id = null;
      this.clasesnet = [];
      this.loading_clasesnet = true;
      let url = process.env.VUE_APP_API_REST + `/api/v1/esam/clasesnetsuite/${this.postgrado.idcategoria.clase_netsuite_id}`;
      let res = await xaxios.get(url).then(x => x).catch(e => e);
      let clases = res.data || [];
      this.clasesnet = clases;
      this.loading_clasesnet = false;
      if (this.postgrado.clasenetsuite) {
        let cn = this.postgrado.clasenetsuite;
        this.postgrado.clase_netsuite_id = clases.find(c => c.id == cn.id);
      }
    },
  },
  mounted() {
    if (this.postgrado_value) {
      const p = this.postgrado_value;
      this.postgrado.id = p.id;
      this.postgrado.nombre = p.nombre;
      this.postgrado.duracion = p.duracion;
      this.postgrado.carga_horaria = p.carga_horaria;
      this.postgrado.creditaje = p.creditaje;
      this.postgrado.dirigido = p.dirigido;
      this.postgrado.objetivo = p.objetivo;
      this.postgrado.unidad_duracion = p.unidad_duracion;
      this.postgrado.fase = p.status;
      this.postgrado.idarea = { id: p.area.id, nombre: p.area.nombre };
      this.postgrado.idcategoria = { id: p.categoria.id, nombre: p.categoria.nombre, clase_netsuite_id: p.categoria.clase_netsuite_id };
      this.postgrado.nombre = this.postgrado.nombre.replace(p.categoria.nombre, '').trim();
      this.postgrado.clasenetsuite = p.clasenetsuite;
      const idrol = this.$store.state.CARGO.id;
      if (idrol == 1) this.activo = true;
      else this.activo = p.status < 1;
    }
  },
};
</script>

<style scoped>
.pa-page { min-height: 100vh; background: #f5f7fa; }

.pa-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.pa-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.pa-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.pa-body { padding: 20px 24px; }

.pa-section-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.pa-section-title {
  font-size: 0.82rem !important;
  font-weight: 700 !important;
  color: #283593;
  letter-spacing: 0.02em;
  border-bottom: 1px solid #e8edf7;
}

.pa-field-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #7986cb;
}

.pa-field-error {
  font-size: 0.75rem;
  color: #c62828;
  margin-top: 2px;
}

.pa-multiselect {
  font-size: 0.875rem;
}
</style>
